import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div className="relative w-full max-w-md mx-auto" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex w-full items-center justify-between gap-3 rounded-lg border border-background-300 bg-background-50 px-4 py-3 text-sm font-medium text-foreground-900 cursor-pointer transition-colors hover:border-primary-300"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className="flex items-center gap-2 whitespace-nowrap">
          <span className="w-5 h-5 flex items-center justify-center text-primary-600">
            <i className="ri-layout-grid-line text-lg" aria-hidden="true"></i>
          </span>
          {t('hero.dropdownLabel')}
        </span>
        <span className="w-5 h-5 flex items-center justify-center text-foreground-500">
          <i className={`ri-arrow-down-s-line text-lg transition-transform ${open ? 'rotate-180' : ''}`} aria-hidden="true"></i>
        </span>
      </button>

      {open && (
        <div className="absolute left-0 right-0 mt-2 max-h-80 overflow-y-auto rounded-lg border border-background-200 bg-background-50 py-1 z-30">
          {categories.map((cat) => (
            <a
              key={cat.key}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setOpen(false)}
              className="flex items-center justify-between gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
            >
              <span className="flex items-center gap-2 whitespace-nowrap">
                <span className="w-4 h-4 flex items-center justify-center text-primary-500">
                  <i className="ri-arrow-right-s-line text-base" aria-hidden="true"></i>
                </span>
                {t(`category.${cat.key}`)}
              </span>
              <span className="w-4 h-4 flex items-center justify-center text-foreground-300">
                <i className="ri-external-link-line text-sm" aria-hidden="true"></i>
              </span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}